import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { selectCurrentTeam, selectCurrentTeamReportsPermissions } from 'containers/app/appSlice';
import { useAppSelector } from 'hooks';
import routesPath from 'routes/RoutesPath';

const isReportsRoute = (pathname: string) =>
  pathname === routesPath.REPORTS || pathname.startsWith(`${routesPath.REPORTS}/`);

export const useReportsAccessGuard = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const currentTeam = useAppSelector(selectCurrentTeam);
  const { accessReports } = useAppSelector(selectCurrentTeamReportsPermissions) ?? {};

  useEffect(() => {
    if (!currentTeam?.id) {
      return;
    }

    if (isReportsRoute(location.pathname) && !accessReports) {
      navigate(routesPath.HOME, { replace: true });
    }
  }, [currentTeam?.id, accessReports, location.pathname, navigate]);
};
